// extracted by mini-css-extract-plugin
module.exports = {"more":"k2Z-I","text":"sVVZi","button":"Eu8l6","text_dayWhite":"_6z0rt","text_open":"yRXDf","button_dayWhite":"VifLw","button_open":"HqHtG"};